export enum IOType {
  input = 'Input',
  output = 'Output',
}
